var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17V8.67342L4.36388 6.31099L2 5V15.5306C2 16.3436 2.67246 17 3.50003 17H7Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H20.5C21.33 17 22 16.3412 22 15.5306V5L19.3225 6.50159L17 8.67337V17Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33734 8.90906L6 5.88977L6.33734 3L11.98 7.09094L17.6226 3L18 5.73375L17.6226 8.90906L11.98 13L6.33734 8.90906Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.31551V9L22 5.7205V3.97139C22 2.34915 19.8825 1.42436 18.4001 2.39725L17 3.31551Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.72051L4.29959 7.22888L7 9V3.31553L5.59991 2.39728C4.11492 1.42432 2 2.34918 2 3.97134V5.72044V5.72051Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGmail);
export default __webpack_public_path__ + "static/media/google-gmail.5bae76407b6f0eccd8d157ff529c747e.svg";
export { ForwardRef as ReactComponent };